import { isMobileOrTablet } from "../../../Views/MobileClassRenderer";
export const labelSpacingPerView = isMobileOrTablet() ? "mb-2" : "mb-2";
